// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import { useTheme } from "@mui/material/styles";

// Styles
import {
  ModalCustomCancel,
  ModalCustomConfirm,
} from "src/styles/mui/muiStylesHelper";
import { UI_SIZES } from "src/constants/uiTokens";

type TimeRangeSwitcherType = {
  isLoading: boolean;
  timeRange: number;
  setTimeRange: React.Dispatch<React.SetStateAction<number>>;
};

const TODAY_RANGE = 0;
const LAST_WEEK_RANGE = 7;

const TimeRangeSwitcher = ({
  isLoading,
  timeRange,
  setTimeRange,
}: TimeRangeSwitcherType) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", gap: "8px" }}>
        <Skeleton
          variant="rounded"
          height={UI_SIZES.inputHeight}
          width={100}
          sx={{
            borderRadius: "4px",
          }}
        />
        <Skeleton
          variant="rounded"
          height={UI_SIZES.inputHeight}
          width={100}
          sx={{
            borderRadius: "4px",
          }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", gap: "8px" }}>
      <Button
        onClick={() => setTimeRange(TODAY_RANGE)}
        sx={{
          ...(timeRange === TODAY_RANGE
            ? ModalCustomConfirm()
            : ModalCustomCancel(theme)),
          maxWidth: "100%",
          // ModalCustomCancel's dark-mode background (#202338) is the same
          // as the page's own paper color here — lighten it a step so the
          // unselected button stays visually distinct.
          ...(timeRange !== TODAY_RANGE &&
            theme.palette.mode === "dark" && {
              backgroundColor: "#4D5063",
            }),
        }}
      >
        <Typography
          maxWidth="100%"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          fontSize="12px"
        >
          {t("Today")}
        </Typography>
      </Button>
      <Button
        onClick={() => setTimeRange(LAST_WEEK_RANGE)}
        sx={{
          ...(timeRange === LAST_WEEK_RANGE
            ? ModalCustomConfirm()
            : ModalCustomCancel(theme)),
          maxWidth: "100%",
          // ModalCustomCancel's dark-mode background (#202338) is the same
          // as the page's own paper color here — lighten it a step so the
          // unselected button stays visually distinct.
          ...(timeRange !== LAST_WEEK_RANGE &&
            theme.palette.mode === "dark" && {
              backgroundColor: "#4D5063",
            }),
        }}
      >
        <Typography
          maxWidth="100%"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          fontSize="12px"
        >
          {t("Last 7 Days")}
        </Typography>
      </Button>
    </Box>
  );
};

export default TimeRangeSwitcher;
